// Copyright 2019 Sorama B.V.

import { PLATFORM } from "aurelia-pal";

export interface IWorkflowModalConfig {
    title: string;
    modulePath: string;
    icon?: string;
    smallModalSize?: boolean;
    canCollapse?: boolean;
}

// Note: This system is flawed because loading modules in this way makes the order in which classes are defined matter
// See FrequencyBandInformationModal
// E.g. if we have EditMeasurementModal implements IModal<EditMeasurementModalState>, the EditMeasurementModalState, should be defined AFTER EditMeasurementModal
export class WorkflowModalCatalog {
    static MeasurementInfo: IWorkflowModalConfig = {
        title: "Measurement Info",
        modulePath: PLATFORM.moduleName("modules/modals/MeasurementInfo/MeasurementInfoModal"),
    };

    static MeasurementSearch: IWorkflowModalConfig = {
        title: "Measurement Search",
        modulePath: PLATFORM.moduleName("modules/modals/MeasurementSearch/MeasurementSearch"),
    };

    static AnalysisModal: IWorkflowModalConfig = {
        title: "Analysis",
        modulePath: PLATFORM.moduleName("modules/modals/Analysis/AnalysisModal"),
        smallModalSize: true,
        canCollapse: true,
    };

    static PsychoAnalysisModal: IWorkflowModalConfig = {
        title: "PsychoAcoustics Further Analysis",
        modulePath: PLATFORM.moduleName("modules/modals/PsychoAnalysis/PsychoAnalysisModal"),
        smallModalSize: true,
    };

    static AnalysisPresetModal: IWorkflowModalConfig = {
        title: "Analysis Presets",
        modulePath: PLATFORM.moduleName("modules/modals/AnalysisPreset/AnalysisPresetModal"),
        smallModalSize: false,
    };

    static ManualChannelSelectionModal: IWorkflowModalConfig = {
        title: "Microphones",
        modulePath: PLATFORM.moduleName("modules/modals/ManualChannelSelection/ManualChannelSelectionModal"),
        smallModalSize: true,
    };

    static PsychoAcousticChannelSelectionModal: IWorkflowModalConfig = {
        title: "Microphones",
        modulePath: PLATFORM.moduleName(
            "modules/modals/PsychoAcousticChannelSelection/PsychoAcousticChannelSelectionModal"
        ),
        smallModalSize: true,
    };

    static ChannelSelectionModal: IWorkflowModalConfig = {
        title: "Selections",
        modulePath: PLATFORM.moduleName("modules/modals/ChannelSelection/ChannelSelectionModal"),
        smallModalSize: true,
    };

    static ImageExportModal: IWorkflowModalConfig = {
        title: "Export Settings",
        modulePath: PLATFORM.moduleName("modules/modals/ImageExport/ImageExportModal"),
        smallModalSize: true,
    };
    static ExportModal: IWorkflowModalConfig = {
        title: "Export Settings",
        modulePath: PLATFORM.moduleName("modules/modals/Export/ExportModal"),
        smallModalSize: true,
    };

    static ImageTransformModal: IWorkflowModalConfig = {
        title: "Select Region of Interest",
        modulePath: PLATFORM.moduleName("modules/modals/ImageTransform/ImageTransformModal"),
    };

    static HelpModal: IWorkflowModalConfig = {
        title: "Help",
        modulePath: PLATFORM.moduleName("modules/modals/Help/HelpModal"),
    };

    static CSVExportModal: IWorkflowModalConfig = {
        title: "CSV Export",
        modulePath: PLATFORM.moduleName("modules/modals/CSVExport/CSVExportModal"),
        smallModalSize: true,
    };

    static FrequencyBandInformationModal: IWorkflowModalConfig = {
        title: "Frequency Bands",
        modulePath: PLATFORM.moduleName("modules/modals/FrequencyBandInformation/FrequencyBandInformationModal"),
    };

    static ImagePickerModal: IWorkflowModalConfig = {
        title: "Image Selection",
        modulePath: PLATFORM.moduleName("modules/modals/ImagePicker/ImagePickerModal"),
    };

    static BeamformProbeModal: IWorkflowModalConfig = {
        title: "Probe",
        modulePath: PLATFORM.moduleName("modules/modals/BeamformProbe/BeamformProbeModal"),
        smallModalSize: true,
    };

    static TimeRangeModal: IWorkflowModalConfig = {
        title: "Time Range",
        modulePath: PLATFORM.moduleName("modules/modals/TimeSelection/TimeSelectionModal"),
        smallModalSize: true,
    };

    static FileImporter: IWorkflowModalConfig = {
        title: "File Selection",
        modulePath: PLATFORM.moduleName("modules/modals/FileImporter/FileImporterModal"),
    };

    static TimeSettingsModal: IWorkflowModalConfig = {
        title: "Settings",
        modulePath: PLATFORM.moduleName("modules/modals/TimeSettings/TimeSettingsModal"),
        smallModalSize: true,
    };

    static SpectrumSettingsModal: IWorkflowModalConfig = {
        title: "Settings",
        modulePath: PLATFORM.moduleName("modules/modals/SpectrumSettings/SpectrumSettingsModal"),
        smallModalSize: true,
    };

    static SpectrogramSettingsModal: IWorkflowModalConfig = {
        title: "Settings",
        modulePath: PLATFORM.moduleName("modules/modals/SpectrogramSettings/SpectrogramSettingsModal"),
        smallModalSize: true,
    };

    static FarfieldSettingsModal: IWorkflowModalConfig = {
        title: "Settings",
        modulePath: PLATFORM.moduleName("modules/modals/FarfieldSettings/FarfieldSettingsModal"),
        smallModalSize: true,
    };

    static NearfieldSettingsModal: IWorkflowModalConfig = {
        title: "Settings",
        modulePath: PLATFORM.moduleName("modules/modals/NearfieldSettings/NearfieldSettingsModal"),
        smallModalSize: true,
    };

    static StreamerSpectrumSettingsModal: IWorkflowModalConfig = {
        title: "Settings",
        modulePath: PLATFORM.moduleName("modules/modals/StreamerSpectrumSettings/StreamerSpectrumSettingsModal"),
        smallModalSize: true,
    };

    static StreamerFarFieldSettingsModal: IWorkflowModalConfig = {
        title: "Settings",
        modulePath: PLATFORM.moduleName("modules/modals/StreamerFarFieldSettings/StreamerFarFieldSettingsModal"),
        smallModalSize: true,
    };

    static StreamerNearFieldSettingsModal: IWorkflowModalConfig = {
        title: "Settings",
        modulePath: PLATFORM.moduleName("modules/modals/StreamerNearFieldSettings/StreamerNearFieldSettingsModal"),
        smallModalSize: true,
    };

    static StreamerSPLSettingsModal: IWorkflowModalConfig = {
        title: "Settings",
        modulePath: PLATFORM.moduleName("modules/modals/StreamerSPLSettings/StreamerSPLSettingsModal"),
        smallModalSize: true,
    };

    static StreamerWaterfallSettingsModal: IWorkflowModalConfig = {
        title: "Settings",
        modulePath: PLATFORM.moduleName("modules/modals/StreamerWaterfallSettings/StreamerWaterfallSettingsModal"),
        smallModalSize: true,
    };

    static EditMeasurementModal: IWorkflowModalConfig = {
        title: "Edit Selection",
        modulePath: PLATFORM.moduleName("modules/workflows/ReportEx/EditMeasurement/EditMeasurementModal"),
    };

    static PreviewMeasurementModal: IWorkflowModalConfig = {
        title: "Measurement Details",
        modulePath: PLATFORM.moduleName("modules/workflows/ReportEx/PreviewMeasurement/PreviewMeasurementModal"),
    };
}
